<script>
import options from "./SearchInputField.options"
export default options
</script>

<template>
  <article class="nyk-search-input-field" :class="{ 'nyk-search-input-field--compact': isCompact, 'nyk-search-input-field--ai-assistant': type === 'ai-assistant' }">
    <strong v-if="!isCompact" class="nyk-hero-topic-pages__subject">{{ legend }}</strong>
    <div class="nyk-search-input-field__input-container">
      <button 
        v-if="type === 'search'"
        :aria-label="searchButtonAriaLabel"
        class="nyk-search-input-field__input-container__icon">

        <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 18">
          <path
            fill="#07094A"
            fill-rule="evenodd"
            d="M1.2 7.344a6.142 6.142 0 1 1 10.562 4.264l-.155.156A6.142 6.142 0 0 1 1.2 7.344Zm10.892 5.599a7.342 7.342 0 1 1 .849-.849l4.632 4.632.424.425-.848.848-.424-.424-4.633-4.632Z"
            clip-rule="evenodd" />
        </svg>
      </button>

      <input
        v-if="isCompact"
        ref="searchInput"
        :maxLength="maxLength"
        v-model="searchInputModel"
        v-on:keyup.enter="onSearchEnter"
        v-on:keyup="inputUpdated"
        :aria-label="searchInputAriaLabel"
        :placeholder="placeholder"
        aria-describedby="search-input-hint"
        autocomplete="off"
        class="nyk-search-input-field__input-container__input" />

      <textarea
        v-if="!isCompact"
        ref="searchTextArea"
        rows="3"
        cols="40"
        :maxLength="maxLength"
        v-model="searchInputModel"
        v-on:keydown.enter="onSearchEnter"
        v-on:keyup="inputUpdated"
        :aria-label="searchInputAriaLabel"
        :placeholder="placeholder"
        aria-describedby="search-input-hint"
        autocomplete="off"
        class="nyk-search-input-field__input-container__textarea">
      </textarea>

      <button
        :aria-label="searchResetAriaLabel"
        v-on:click="emptyInput"
        class="nyk-search-input-field__input-container__close"
        :class="{
          'nyk-search-input-field__input-container__close--show': inputIsNotEmpty,
        }">
        <span aria-hidden="true" class="nyk-icon nyk-icon--ui-close"></span>
      </button>

      <ChatSendButton 
        v-if="type === 'ai-assistant'"
        class="nyk-search-input-field__input-container__send"
        :aria-label="searchButtonAriaLabel" 
        :disabled="!!!searchInputModel" 
        @send="onSearchEnter" 
      />
    </div>
    <div v-if="hint && !isCompact" id="search-input-hint" class="nyk-search-input-field__hint" v-html="hint"></div>
  </article>
</template>